export default __webpack_public_path__ + "static/media/attila-screaming.964b4b9c.jpeg";